import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Megaphone, Star, Users, Sparkles, CheckCircle2 } from "lucide-react";

const CreatorBooking = () => {
  return (
    <section className="py-24 md:py-32 bg-neutral-950 text-white relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-20%] left-[20%] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(236,72,153,0.22),transparent_60%)]" />
        <div className="absolute bottom-[-30%] right-[10%] w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,rgba(249,115,22,0.18),transparent_60%)]" />
      </div>

      <div className="max-w-[1300px] mx-auto px-6 md:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-xs uppercase tracking-[0.2em] font-semibold text-neutral-300">
              <Megaphone size={14} className="text-pink-400" />
              Creator & Influencer
            </span>
            <h2 className="font-display font-extrabold text-4xl md:text-6xl lg:text-7xl tracking-[-0.03em] leading-[1.02] mt-6">
              Buche{" "}
              <span className="bg-gradient-to-r from-pink-400 via-orange-400 to-purple-400 bg-clip-text text-transparent">
                UGC Creator & Influencer
              </span>{" "}über uns.
            </h2>
            <p className="mt-6 text-lg text-neutral-300 leading-relaxed max-w-xl">
              Wir vermitteln nicht nur Reichweite – wir vermarkten unsere
              Creator strategisch. Authentischer Content, klare
              Brand-Botschaft und messbare Ergebnisse statt bloßer
              Follower-Zahlen.
            </p>

            <ul className="mt-8 space-y-3 max-w-md">
              {[
                "Hand-selektierte UGC Creator für eure Branche",
                "Influencer Marketing mit klarer Performance-Logik",
                "Wir managen Briefing, Content & Reporting",
                "Direkter Draht – keine Plattform dazwischen",
              ].map((b, i) => (
                <li key={i} className="flex items-start gap-3 text-neutral-200">
                  <CheckCircle2
                    size={20}
                    className="text-orange-400 shrink-0 mt-0.5"
                  />
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10">
              <Link
                to="/kontakt"
                className="group inline-flex items-center gap-3 px-8 py-5 rounded-full bg-white text-neutral-950 text-sm font-bold tracking-[0.12em] uppercase hover:bg-gradient-to-r hover:from-pink-400 hover:via-orange-400 hover:to-purple-400 hover:text-white transition-all duration-300"
              >
                Creator anfragen
                <ArrowRight
                  size={18}
                  className="transition-transform duration-300 group-hover:translate-x-1"
                />
              </Link>
            </div>
          </div>

          <div className="lg:col-span-6 grid grid-cols-2 gap-4">
            {[
              { icon: Users, title: "50+ Creator", desc: "Im Netzwerk verfügbar", grad: "from-pink-500/20 to-purple-500/20" },
              { icon: Star, title: "Top UGC", desc: "5★ Speekly rated", grad: "from-orange-500/20 to-pink-500/20" },
              { icon: Sparkles, title: "Performance", desc: "Hook → CTA Logic", grad: "from-purple-500/20 to-pink-500/20" },
              { icon: Megaphone, title: "Influencer", desc: "Mit Strategie & ROI", grad: "from-pink-500/20 to-orange-500/20" },
            ].map((card, i) => {
              const Ico = card.icon;
              return (
                <div
                  key={i}
                  className={`p-6 rounded-3xl bg-gradient-to-br ${card.grad} backdrop-blur-xl border border-white/10 hover:border-white/20 hover:-translate-y-1 transition-all duration-500`}
                >
                  <div className="w-11 h-11 rounded-2xl bg-white/10 flex items-center justify-center">
                    <Ico size={20} className="text-white" />
                  </div>
                  <div className="mt-5 font-display font-extrabold text-2xl tracking-tight">
                    {card.title}
                  </div>
                  <div className="mt-1 text-sm text-neutral-300">
                    {card.desc}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreatorBooking;
